export default {"src":"/_next/static/media/map-marker-white.78d66455.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};